<template>
<div class="body1">
 <el-form  :model="form1" :rules="rules" ref="form1" label-width="100px" class="demo-ruleForm">
  <el-form-item label="用户名" prop="username">
    <el-input v-model="form1.username"></el-input>
  </el-form-item>
   <el-form-item label="密码" prop="password">
    <el-input type="password" v-model="form1.password"></el-input>
  </el-form-item>
   <el-form-item label="姓名" prop="linkman">
    <el-input v-model="form1.linkman"></el-input>
  </el-form-item>
   <el-form-item label="手机号" prop="mobile">
    <el-input v-model="form1.mobile"></el-input>
  </el-form-item>
  <el-form-item label="邮箱" prop="dept">
    <el-input v-model="form1.dept"></el-input>
  </el-form-item>

  <el-form-item>
    <el-button type="primary" @click="checkForm('form1')"  @keyup.enter.native="checkForm('form1')">保存</el-button>
  </el-form-item>
</el-form>
   </div>
</template>

<script>
import rootPathssb from '@/api/mainApi'
import { dataGetUrl, dataPost } from '@/api/index'
export default {
  name: 'adminmanageupdate',
  data () {
    var userName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入用户名'))
      } else {
        callback()
      }
    }
    var passWord = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    var Linkman = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入姓名'))
      } else {
        callback()
      }
    }
    var Mobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号码不能为空'))
      } else {
        const reg = /^1[3456789]\d{9}$/
        console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号码'))
        }
      }
    }
    var Dept = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      } else {
        const reg = /^([a-zA-Z]|[0-9])(\w|)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
        console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的邮箱'))
        }
      }
    }
    return {
      form1: {
        username: '阿萨德',
        password: '12345',
        linkman: ' 阿萨德',
        state: '1',
        dept: '灌灌灌灌',
        adminType: '1',
        mobile: '123123123'

      },

      options: [{
        value: '1',
        label: '超级管理员'
      }, {
        value: '2',
        label: '机构用户'
      } ],
      value: '',

      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { validator: userName, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: passWord, trigger: 'blur' }
        ],
        linkman: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { validator: Linkman, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: Mobile, trigger: 'blur' }
        ],
        dept: [
          { required: true, message: '输入邮箱', trigger: 'blur' },
          { validator: Dept, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    var that = this
    /* 获取父页面参数 */

    /* 后台申请默认值 */
    dataGetUrl(rootPathssb.rootPath + '/admini/find?id=' + that.$route.query.pid).then(function (response) {
      that.checkSignin(response.data.result)
      if (response.data.result === 1) {
        console.log('cg')
        that.form1 = response.data.object
      };

      console.log(response.data)
    }).catch(function (error) {
      console.log(error); console.log('aaa')
    })
  },
  methods: {
    submitForm (event) {
      var params = new URLSearchParams()
      let that = this
      params.append('id', this.form1.id)
      params.append('username', this.form1.username)
      params.append('password', this.form1.password)
      params.append('linkman', this.form1.linkman)
      params.append('mobile', this.form1.mobile)
      params.append('dept', this.form1.dept)
      params.append('adminType', this.form1.adminType)
      if (that.form1.username === '') { alert('请输入用户账号') } else if (that.form1.password === '') { alert('请输入用户密码') } else if (that.form1.linkman === '') { alert('请输入联系人') } else if (that.form1.mobile === '') { alert('请输入联系电话') } else if (that.form1.dept === '') { alert('请输入负责人部门') } else if (that.form1.state === '') { alert('请输入用户类型') } else {
        dataPost(rootPathssb.rootPath + '/admini/update', params).then(function (response) {
          that.checkSignin(response.data.result)
          if (response.data.result === 1) {
            alert('保存成功')
            that.$router.push({path: '/adminmanage'})
            console.log('cg')
          };

          console.log(response.data)
        }).catch(function (error) {
          console.log(error); console.log(2222222222); alert('失败')
        })
      }
    },
    checkSignin (sta) {
      if (sta === -1) {
        window.location.href = '/signin'
      }
    },
    checkForm (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.submitForm()
          console.log('成功!')
        } else {
          console.log('提交失败')
          return false
        }
      })
    }
  }

}
</script>

<style scoped>
.body1{
  width:600px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/adminmanageupdate.vue